import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { FullscreenStatus } from "@/components/layout/FullscreenStatus";
import { initializeI18n, i18n } from "@/i18n";
import { router } from "@/app/router";
import { authStore } from "@/stores/authStore";
import { subscriptionStore } from "@/stores/subscriptionStore";

export function App() {
  const [isI18nReady, setIsI18nReady] = useState(i18n.isInitialized);

  useEffect(() => {
    let isMounted = true;

    void initializeI18n().then(() => {
      if (isMounted) {
        setIsI18nReady(true);
      }
    });

    void authStore.getState().hydrate();
    void subscriptionStore.getState().hydratePricing();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isI18nReady) {
    return <FullscreenStatus title="Loading interface..." />;
  }

  return (
    <I18nextProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nextProvider>
  );
}
